import PropTypes from 'prop-types';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import { selectIsMobile } from 'redux/selectors/layout';
import LinkWrapper from 'components/Common/LinkWrapper';
import useAppearingAnimation from 'hooks/useAppearingAnimation';
import { ROUTES } from 'utils/constants';
import styles from './styles.module.scss';

const IntroText = ({ className }) => {
  const isMobileResolution = useSelector(selectIsMobile);
  const [direction, isTopOfPage] = useAppearingAnimation(isMobileResolution);

  return (
    <div
      className={cn(
        'intro-text',
        styles.introTextContainer,
        className,
        styles[direction],
        {
          [styles.notOnTop]: !isTopOfPage,
        },
      )}
    >
      <p className={styles.introText}>
        We build AI-first products for clients who change the world.
      </p>
      <LinkWrapper
        isLocalLink
        path={ROUTES.contact.path}
        dynamicRouting={ROUTES.contact.dynamicPath}
        className={styles.introLink}
      >
        Get in touch
      </LinkWrapper>
    </div>
  );
};

IntroText.defaultProps = {
  className: '',
};

IntroText.propTypes = {
  className: PropTypes.string,
};

export default IntroText;
